import { LogoutReason } from '@eih-netbroker/common';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/error-warning-fill.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { NbButton } from '../../../shared/components/button/Button';
import { NbIconButton } from '../../../shared/components/icon-button/IconButton';
import classes from './UnsuccessfulLoginModal.module.scss';

export interface UnsuccessfulLoginModalProps {
  reason: Exclude<LogoutReason, 'SSOCallbackError' | 'OtherInstanceLoggedOut'>;
  onClose: () => void;
}

export const UnsuccessfulLoginModal = ({ onClose, reason }: UnsuccessfulLoginModalProps) => {
  const { translation } = useLocale();

  return (
    <div className={classes.modal}>
      <div className={classes.modalClose}>
        <NbIconButton
          icon={<CloseIcon />}
          onClick={onClose}
        />
      </div>

      <div className={classes.modalContent}>
        {/*Logged out reasoning*/}
        {reason === LogoutReason.InactivityTimeout && (
          <>
            <h4>{translation.logoutModal.titleAfterTimeout}</h4>

            <p className={classes.modalContentText}>{translation.logoutModal.textAfterTimeout}</p>
          </>
        )}

        {/*User is disabled*/}
        {reason === LogoutReason.UserDisabled && (
          <>
            <h4>{translation.unsuccessfulLoginModal.title}</h4>
            <p className={classes.modalContentText}>{translation.unsuccessfulLoginModal.userDisabled.lead}</p>
            <p className={classes.modalContentText}>{translation.unsuccessfulLoginModal.userDisabled.subLead}</p>
            <p
              className={classes.modalContentText}
              dangerouslySetInnerHTML={{ __html: translation.unsuccessfulLoginModal.userDisabled.content }}
            ></p>
          </>
        )}

        {/*Error during login*/}
        {reason !== LogoutReason.InactivityTimeout &&
          reason !== LogoutReason.ErrorWhileSavingConsent &&
          reason !== LogoutReason.UserDisabled && (
            <>
              <h4>{translation.unsuccessfulLoginModal.title}</h4>
              <p className={classes.modalContentSubtitle}>
                <ErrorIcon /> {translation.unsuccessfulLoginModal.subtitle}
              </p>
              <p className={classes.modalContentText}>{translation.unsuccessfulLoginModal.errors[reason]}</p>

              {/*// TODO: add error code once we have it*/}
              {/*<p className={classes.modalContentError}>{translation.unsuccessfulLoginModal.errorCode}</p>*/}
              {/*<p className={classes.modalContentError}>123456789</p>*/}
            </>
          )}

        <div className={classes.modalContentButton}>
          <NbButton onClick={onClose}>{translation.unsuccessfulLoginModal.button}</NbButton>
        </div>
      </div>
    </div>
  );
};
